
import Cookies from 'js-cookie';

// Done like this so you can change the cookie library in future
// without changing rest of the code where this is imported

const cookie = {

  /**
   * Saves value to a cookie
   *
   * @param {string} name . Cookie name
   * @param {object|array|string|number} value - Cookie value (will be stringified)
   * @param {object} options - Optional settings object to control cookie. see js-cookie documentation.
   */
  set: function(name, value, options) {
    const defaultOptions = {
      expires: 365
    };

    let cookieValue = value;

    if(typeof value !== 'string') {
      cookieValue = JSON.stringify(value);
    }

    Cookies.set(name, cookieValue, Object.assign({}, defaultOptions, options));
  },

  /**
   * Reads cookie value
   *
   * @param {string} cookieName - Name of cookie
   * @return {string} - cookie value
   */
  get: function(cookieName) {
    return Cookies.get(cookieName);
  },

  /**
   * Deletes cookie
   *
   * @param {string} cookieName - Name of cookie
   * @return {?} - ?
   */
  remove: function(cookieName) {
    return Cookies.remove(cookieName);
  }
};

export default cookie;
